/* Zillabeau image viewer (Sean 2026-09-25: on phones "View full image" showed a cropped part, no pinch zoom, hard to close).
   window.zbmZoom.open(src, alt, trigger, title)
   - opens full screen, image fitted to the screen (very tall posters: fitted to the width, starting at the top)
   - pinch / double-tap / mouse wheel to zoom (up to 6x), drag to move when zoomed
   - close: big Close button, Esc, tap outside the image, swipe down (when not zoomed), or the phone's Back button
   v2 (smoothness on iPhone): touch events (not pointer events) with preventDefault, Safari gesture* events blocked while open,
   one transform write per animation frame (translate3d), pinch anchored to the point under the fingers at gesture start. */
(function () {
  if (window.zbmZoom) return;
  var ov, stage, img, titleEl, hint;
  var s = 1, base = 1, tx = 0, ty = 0, iw = 0, ih = 0;
  var gest = null, lastTap = 0, lastTapX = 0, lastTapY = 0, trigger = null, pushed = false, prevOverflow = '', hintTimer = null;
  var raf = 0, animNext = false, swipeDy = 0;

  /* ---------- rendering ---------- */
  function render() {
    raf = 0;
    img.style.transition = animNext ? 'transform 200ms ease' : 'none';
    animNext = false;
    img.style.transform = 'translate3d(' + tx + 'px,' + (ty + swipeDy) + 'px,0) scale(' + s + ')';
    ov.style.backgroundColor = swipeDy > 0 ? 'rgba(20,19,18,' + Math.max(0.35, 1 - swipeDy / 600) + ')' : '';
  }
  function schedule(anim) { if (anim) animNext = true; if (!raf) raf = requestAnimationFrame(render); }
  function W() { return stage.clientWidth; }
  function H() { return stage.clientHeight; }
  function clamp() {
    var w = iw * s, h = ih * s;
    tx = w <= W() ? (W() - w) / 2 : Math.min(0, Math.max(W() - w, tx));
    ty = h <= H() ? (H() - h) / 2 : Math.min(0, Math.max(H() - h, ty));
  }
  function fit(anim) {
    var tall = ih / iw > 2.2 && (W() / iw) * ih > H() * 1.4;
    base = tall ? W() / iw : Math.min(W() / iw, H() / ih);
    s = base; tx = (W() - iw * s) / 2; ty = tall ? 0 : (H() - ih * s) / 2;
    clamp(); schedule(anim);
  }
  function limit(ns) { return Math.max(base, Math.min(base * 6, ns)); }
  function zoomAt(ns, cx, cy, anim) {
    ns = limit(ns);
    tx = cx - (cx - tx) * ns / s; ty = cy - (cy - ty) * ns / s; s = ns;
    clamp(); schedule(anim);
  }
  function canPan() { return iw * s > W() + 1 || ih * s > H() + 1; }
  function onImage(x, y) { return x >= tx && x <= tx + iw * s && y >= ty && y <= ty + ih * s; }
  function pt(t) { var r = stage.getBoundingClientRect(); return { x: t.clientX - r.left, y: t.clientY - r.top }; }

  /* ---------- gestures (shared by touch and mouse) ---------- */
  function startPan(p) { gest = { kind: 'pan', x: p.x, y: p.y, tx: tx, ty: ty, moved: false }; }
  function startPinch(a, b) {
    var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
    // image coordinates under the fingers' midpoint stay under the midpoint while zooming
    gest = { kind: 'pinch', d: Math.hypot(a.x - b.x, a.y - b.y) || 1, s: s, ix: (mx - tx) / s, iy: (my - ty) / s };
  }
  function movePinch(a, b) {
    var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
    var ns = limit(gest.s * (Math.hypot(a.x - b.x, a.y - b.y) || 1) / gest.d);
    s = ns; tx = mx - gest.ix * s; ty = my - gest.iy * s;
    clamp(); schedule(false);
  }
  function movePan(p) {
    var dx = p.x - gest.x, dy = p.y - gest.y;
    if (Math.abs(dx) + Math.abs(dy) > 6) gest.moved = true;
    if (canPan()) { tx = gest.tx + dx; ty = gest.ty + dy; clamp(); swipeDy = 0; }
    else if (!gest.mouse) swipeDy = Math.max(0, dy);              // not zoomed: swipe down to close (touch only — a mouse drag never closes)
    schedule(false);
  }
  function endPan(p) {
    var g = gest; gest = null;
    var closeBySwipe = swipeDy > 110; swipeDy = 0;
    if (closeBySwipe) { close(true); return; }
    if (g.moved) { clamp(); schedule(true); return; }
    // tap / double tap
    var now = Date.now();
    if (now - lastTap < 320 && Math.abs(p.x - lastTapX) < 30 && Math.abs(p.y - lastTapY) < 30) {
      lastTap = 0;
      if (s > base * 1.05) fit(true); else zoomAt(base * 2.5, p.x, p.y, true);
      return;
    }
    lastTap = now; lastTapX = p.x; lastTapY = p.y;
    if (!onImage(g.x, g.y)) setTimeout(function () { if (lastTap === now) close(true); }, 300);   // single tap outside the image
    schedule(false);
  }

  /* touch (iPhone / Android) */
  function touches(e) { var a = []; for (var i = 0; i < e.touches.length; i++) a.push(pt(e.touches[i])); return a; }
  function onTouchStart(e) {
    if (e.target.closest('[data-z]')) return;
    e.preventDefault(); hideHint();
    var t = touches(e);
    if (t.length >= 2) startPinch(t[0], t[1]); else if (t.length === 1) startPan(t[0]);
  }
  function onTouchMove(e) {
    if (!gest) return;
    e.preventDefault();
    var t = touches(e);
    if (gest.kind === 'pinch' && t.length >= 2) movePinch(t[0], t[1]);
    else if (gest.kind === 'pan' && t.length === 1) movePan(t[0]);
  }
  function onTouchEnd(e) {
    if (!gest) return;
    e.preventDefault();
    var t = touches(e);
    if (gest.kind === 'pinch') {
      if (t.length >= 2) startPinch(t[0], t[1]);                  // a third finger lifted — keep pinching
      else if (t.length === 1) { startPan(t[0]); gest.moved = true; }  // one finger left: continue as a pan, no tap
      else { gest = null; clamp(); schedule(true); }
      return;
    }
    var c = e.changedTouches && e.changedTouches[0];
    endPan(c ? pt(c) : { x: gest.x, y: gest.y });
  }

  /* mouse (desktop) */
  function onMouseDown(e) { if (e.button !== 0 || e.target.closest('[data-z]')) return; e.preventDefault(); startPan(pt(e)); gest.mouse = true; }
  function onMouseMove(e) { if (gest && gest.kind === 'pan') movePan(pt(e)); }
  function onMouseUp(e) { if (gest && gest.kind === 'pan') endPan(pt(e)); }
  function blockGesture(e) { if (ov && !ov.hidden) e.preventDefault(); }   // Safari's own page zoom

  function build() {
    ov = document.createElement('div');
    ov.className = 'zbm-zoom'; ov.hidden = true;
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Image viewer');
    ov.innerHTML = '<div class="zbm-zoom-bar"><span class="zbm-zoom-t"></span>' +
      '<button type="button" class="zbm-zoom-btn" data-z="out" aria-label="Zoom out">&minus;</button>' +
      '<button type="button" class="zbm-zoom-btn" data-z="in" aria-label="Zoom in">+</button>' +
      '<button type="button" class="zbm-zoom-x" data-z="close">Close &times;</button></div>' +
      '<div class="zbm-zoom-stage"><img class="zbm-zoom-img" alt="" draggable="false"><span class="zbm-zoom-hint">' + (matchMedia('(pointer: fine)').matches ? 'Scroll or drag to move · Ctrl + scroll or +/− to zoom' : 'Pinch or double-tap to zoom') + '</span></div>';
    document.body.appendChild(ov);
    stage = ov.querySelector('.zbm-zoom-stage'); img = ov.querySelector('.zbm-zoom-img');
    titleEl = ov.querySelector('.zbm-zoom-t'); hint = ov.querySelector('.zbm-zoom-hint');
    ov.addEventListener('click', function (e) {
      var b = e.target.closest('[data-z]'); if (!b) return;
      var z = b.getAttribute('data-z');
      if (z === 'close') close(true);
      else zoomAt(z === 'in' ? s * 1.6 : s / 1.6, W() / 2, H() / 2, true);
    });
    stage.addEventListener('touchstart', onTouchStart, { passive: false });
    stage.addEventListener('touchmove', onTouchMove, { passive: false });
    stage.addEventListener('touchend', onTouchEnd, { passive: false });
    stage.addEventListener('touchcancel', onTouchEnd, { passive: false });
    stage.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (n) { document.addEventListener(n, blockGesture, { passive: false }); });
    // desktop (Sean 2026-10-01: a tall image was cut off and could not be moved): the plain wheel / trackpad scrolls the
    // image when it is bigger than the screen; Ctrl/Cmd + wheel (or pinch on a trackpad) zooms.
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      hideHint();
      var p = pt(e);
      if (e.ctrlKey || e.metaKey) { zoomAt(s * Math.exp(-Math.max(-60, Math.min(60, e.deltaY)) * 0.004), p.x, p.y); return; }
      // plain wheel only ever moves the image (never zooms — wheel-up used to zoom in, so scrolling up felt broken)
      if (canPan()) { tx -= e.shiftKey ? e.deltaY : e.deltaX; ty -= e.shiftKey ? 0 : e.deltaY; clamp(); schedule(false); }
    }, { passive: false });
    stage.addEventListener('mousemove', function () { stage.style.cursor = gest ? 'grabbing' : (canPan() ? 'grab' : 'zoom-in'); });
    img.addEventListener('load', function () { iw = img.naturalWidth; ih = img.naturalHeight; img.style.width = iw + 'px'; img.style.height = ih + 'px'; fit(false); ov.classList.remove('is-loading'); });
    window.addEventListener('resize', function () { if (!ov.hidden && iw) fit(false); });
    document.addEventListener('keydown', function (e) {
      if (!ov || ov.hidden) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(true); }
      else if (e.key === '+' || e.key === '=') zoomAt(s * 1.6, W() / 2, H() / 2, true);
      else if (e.key === '-') zoomAt(s / 1.6, W() / 2, H() / 2, true);
      else if (/^(ArrowUp|ArrowDown|PageUp|PageDown|Home|End)$/.test(e.key) && canPan()) {
        e.preventDefault();
        var step = /Page/.test(e.key) ? H() * 0.9 : 120;
        if (e.key === 'ArrowUp' || e.key === 'PageUp') ty += step; else if (e.key === 'ArrowDown' || e.key === 'PageDown') ty -= step; else if (e.key === 'Home') ty = 0; else ty = H() - ih * s;
        clamp(); schedule(true);
      }
    });
    window.addEventListener('popstate', function () { if (ov && !ov.hidden) { pushed = false; close(false); } });
  }

  function showHint() { hint.classList.add('is-on'); clearTimeout(hintTimer); hintTimer = setTimeout(hideHint, 2600); }
  function hideHint() { hint.classList.remove('is-on'); }

  function open(src, alt, trig, title) {
    if (!src) return;
    if (!ov) build();
    trigger = trig || document.activeElement;
    titleEl.textContent = title || alt || '';
    img.alt = alt || '';
    iw = ih = 0; gest = null; swipeDy = 0; ov.classList.add('is-loading');
    img.removeAttribute('style');
    img.src = src;
    ov.hidden = false;
    prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('zbm-zoom-open');
    try { history.pushState({ zbmZoom: 1 }, ''); pushed = true; } catch (err) { pushed = false; }
    if (img.complete && img.naturalWidth) { iw = img.naturalWidth; ih = img.naturalHeight; img.style.width = iw + 'px'; img.style.height = ih + 'px'; fit(false); ov.classList.remove('is-loading'); }
    showHint();
    var x = ov.querySelector('.zbm-zoom-x'); x && x.focus({ preventScroll: true });
  }
  function close(viaUi) {
    if (!ov || ov.hidden) return;
    ov.hidden = true; gest = null; swipeDy = 0;
    if (raf) { cancelAnimationFrame(raf); raf = 0; }
    img.removeAttribute('src');
    ov.style.backgroundColor = '';
    document.documentElement.style.overflow = prevOverflow;
    document.documentElement.classList.remove('zbm-zoom-open');
    if (viaUi && pushed) { pushed = false; try { history.back(); } catch (err) {} }
    if (trigger && trigger.focus) { try { trigger.focus({ preventScroll: true }); } catch (err) {} }
    trigger = null;
  }
  window.zbmZoom = { open: open, close: function () { close(true); } };
})();
